(function () {
  var cfg = window.SBRTrackerConfig || {};
  if (cfg.enabled === false) return;

  var config = {
    enabled: cfg.enabled !== false,
    writeToCart: cfg.writeToCart !== false,
    cartAttributeKey: cfg.cartAttributeKey || 'Source_Log',
    maxChars: typeof cfg.maxChars === 'number' ? cfg.maxChars : 12000,
    logNavClicks: cfg.logNavClicks !== false,
    sendToCloudflare: cfg.sendToCloudflare === true && !!cfg.cloudflareEndpoint,
    cloudflareEndpoint: cfg.cloudflareEndpoint || '',
    sessionTimeoutMinutes: typeof cfg.sessionTimeoutMinutes === 'number' ? cfg.sessionTimeoutMinutes : 30,
    flushQueueSize: typeof cfg.flushQueueSize === 'number' ? cfg.flushQueueSize : 20
  };

  var storageKeys = {
    queue: 'sbr_event_queue_v1',
    session: 'sbr_session_v1',
    summary: 'sbr_summary_v1'
  };

  var memoryQueue = [];
  var memorySession = null;
  var flushInProgress = false;
  var flushPromise = null;
  var lastCheckoutLogAt = 0;
  var autoFlushTimer = null;
  var lastAutoFlushAt = 0;
  var autoFlushIntervalMs = 15000;
  var autoFlushMinGapMs = 5000;
  var summaryCache = null;

  function nowIso() {
    return new Date().toISOString();
  }

  function safeParse(json, fallback) {
    try {
      return JSON.parse(json);
    } catch (e) {
      return fallback;
    }
  }

  function getQueue() {
    try {
      var raw = window.localStorage.getItem(storageKeys.queue);
      if (raw) return safeParse(raw, []).filter(Boolean);
    } catch (e) {}
    return memoryQueue.slice();
  }

  function setQueue(queue) {
    memoryQueue = queue.slice();
    try {
      window.localStorage.setItem(storageKeys.queue, JSON.stringify(queue));
    } catch (e) {}
  }

  function getSession() {
    var now = Date.now();
    var timeoutMs = config.sessionTimeoutMinutes * 60 * 1000;
    var session = null;

    try {
      session = safeParse(window.localStorage.getItem(storageKeys.session), null);
    } catch (e) {}

    if (!session && memorySession) session = memorySession;

    var isNew = false;
    if (!session || !session.id || !session.last || now - session.last > timeoutMs) {
      session = {
        id: generateId(),
        start: now,
        last: now
      };
      isNew = true;
    } else {
      session.last = now;
    }

    memorySession = session;
    try {
      window.localStorage.setItem(storageKeys.session, JSON.stringify(session));
    } catch (e) {}

    return { session: session, isNew: isNew };
  }

  function getSummary() {
    try {
      var raw = window.localStorage.getItem(storageKeys.summary);
      if (raw) summaryCache = safeParse(raw, null);
    } catch (e) {}
    return summaryCache;
  }

  function setSummary(summary) {
    summaryCache = summary;
    try {
      window.localStorage.setItem(storageKeys.summary, JSON.stringify(summary));
    } catch (e) {}
  }

  function ensureSummary(sessionId) {
    var summary = getSummary();
    if (!summary || summary.sid !== sessionId) {
      summary = {
        sid: sessionId,
        createdAt: nowIso(),
        landingUrl: '',
        referrer: '',
        pages: [],
        navClicks: [],
        atcClicks: []
      };
      setSummary(summary);
    }
    return summary;
  }

  function pushUnique(list, value, max) {
    if (!value) return;
    if (list.indexOf(value) !== -1) return;
    list.push(value);
    if (max && list.length > max) list.shift();
  }

  function pushBounded(list, value, max) {
    if (!value) return;
    list.push(value);
    if (max && list.length > max) list.shift();
  }

  function updateSummary(event) {
    if (!event || !event.sid) return;
    var summary = ensureSummary(event.sid);

    if (!summary.landingUrl) {
      summary.landingUrl = (event.data && event.data.landing_url) || (event.data && event.data.url) || (event.page && event.page.url) || '';
    }
    if (!summary.referrer) {
      summary.referrer = (event.data && event.data.referrer) || (event.page && event.page.ref) || '';
    }

    if (event.evt === 'page_view') {
      var pageUrl = (event.data && event.data.url) || (event.page && event.page.url) || '';
      pushUnique(summary.pages, pageUrl, 40);
    }

    if (event.evt === 'nav_click') {
      var nav = {
        from: event.data && event.data.from,
        to: event.data && event.data.to,
        text: (event.data && event.data.text) ? String(event.data.text).replace(/\s+/g, ' ').trim().slice(0, 140) : '',
        label: (event.data && event.data.label) ? String(event.data.label).replace(/\s+/g, ' ').trim().slice(0, 140) : '',
        location: event.data && event.data.location
      };
      pushBounded(summary.navClicks, nav, 80);
    }

    if (event.evt === 'add_to_cart') {
      var atc = {
        source: event.data && event.data.source,
        product_title: event.data && event.data.product_title,
        variant_id: event.data && event.data.variant_id,
        quantity: event.data && event.data.quantity,
        recipe_title: event.data && event.data.recipe_title,
        ingredient_name: event.data && event.data.ingredient_name,
        button_label: event.data && event.data.button_label
      };
      pushBounded(summary.atcClicks, atc, 40);
    }

    setSummary(summary);
  }

  function generateId() {
    return 'sbr_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function pageContext() {
    return {
      type: cfg.pageType || '',
      template: cfg.template || '',
      title: cfg.pageTitle || document.title || '',
      handle: cfg.resourceHandle || '',
      id: cfg.resourceId || null,
      resource: cfg.resourceType || ''
    };
  }

  function buildEvent(evt, data) {
    var sessionInfo = getSession();
    return {
      v: 'sbr-1',
      ts: nowIso(),
      evt: evt,
      sid: sessionInfo.session.id,
      shop: cfg.shop || '',
      page: {
        url: window.location.href,
        path: window.location.pathname + window.location.search + window.location.hash,
        ref: document.referrer || '',
        context: pageContext()
      },
      customer: cfg.customerId ? { id: cfg.customerId } : null,
      data: data || {}
    };
  }

  function enqueue(event, opts) {
    if (!config.enabled) return;
    updateSummary(event);
    var queue = getQueue();
    queue.push(event);
    setQueue(queue);

    if (opts && opts.flush) {
      flush('manual');
      return;
    }

    if (config.flushQueueSize && queue.length >= config.flushQueueSize) {
      flush('threshold');
    }
  }

  function buildSummaryText(summary) {
    if (!summary) return '';
    var lines = [];
    lines.push('SBR Summary');
    lines.push('Landing Page: ' + (summary.landingUrl || ''));
    lines.push('Referrer: ' + (summary.referrer || ''));
    lines.push('Pages Visited:');
    if (summary.pages && summary.pages.length) {
      summary.pages.forEach(function (url, idx) {
        lines.push('• ' + (idx + 1) + ') ' + url);
      });
    } else {
      lines.push('• (none)');
    }
    lines.push('Navigation Clicks:');
    if (summary.navClicks && summary.navClicks.length) {
      summary.navClicks.forEach(function (item, idx) {
        var label = (item.from || '') + ' -> ' + (item.to || '');
        var meta = [];
        if (item.label) meta.push('button: "' + item.label + '"');
        if (item.text && item.text !== item.label) meta.push('text: "' + item.text + '"');
        if (item.location) meta.push('area: ' + item.location);
        if (meta.length) label += ' | ' + meta.join(' | ');
        lines.push('• ' + (idx + 1) + ') ' + label.trim());
      });
    } else {
      lines.push('• (none)');
    }
    lines.push('Add-to-Cart Clicks:');
    if (summary.atcClicks && summary.atcClicks.length) {
      summary.atcClicks.forEach(function (item, idx) {
        var parts = [];
        if (item.product_title) parts.push(item.product_title);
        if (item.quantity) parts.push('qty ' + item.quantity);
        if (item.variant_id) parts.push('variant ' + item.variant_id);
        if (item.source) parts.push('source ' + item.source);
        if (item.button_label) parts.push('button "' + item.button_label + '"');
        if (item.recipe_title) parts.push('recipe ' + item.recipe_title);
        if (item.ingredient_name) parts.push('ingredient ' + item.ingredient_name);
        lines.push('• ' + (idx + 1) + ') ' + parts.join(' | '));
      });
    } else {
      lines.push('• (none)');
    }
    return lines.join('\n');
  }

  function appendToCartAttribute(existing, payload) {
    var combined = '';
    if (existing && typeof existing === 'string') {
      combined = existing.replace(/\n?$/, '\n') + payload + '\n';
    } else {
      combined = payload + '\n';
    }
    if (config.maxChars && combined.length > config.maxChars) {
      combined = combined.slice(combined.length - config.maxChars);
    }
    return combined;
  }

  function postToCloudflare(events) {
    if (!config.sendToCloudflare || !config.cloudflareEndpoint) return;
    var payload = {
      v: 'sbr-1',
      shop: cfg.shop || '',
      session: (getSession().session || {}).id || null,
      events: events
    };

    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(config.cloudflareEndpoint, blob);
      } else {
        fetch(config.cloudflareEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function flush(reason) {
    if (!config.writeToCart) return Promise.resolve(false);

    if (flushInProgress) return flushPromise || Promise.resolve(false);

    var queue = getQueue();
    if (!queue.length) return Promise.resolve(false);

    flushInProgress = true;

    flushPromise = (async function () {
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var cartRes = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        var cart = cartRes.ok ? await cartRes.json() : null;
        var summary = getSummary();
        var payload = buildSummaryText(summary);
        if (payload && config.maxChars && payload.length > config.maxChars) {
          payload = payload.slice(0, config.maxChars);
        }
        var nextValue = payload || '';

        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: (function () {
              var out = {};
              out[config.cartAttributeKey] = nextValue;
              return out;
            })()
          }),
          credentials: 'same-origin'
        });

        setQueue([]);
        postToCloudflare(queue);
        return true;
      } catch (e) {
        return false;
      } finally {
        flushInProgress = false;
      }
    })();

    return flushPromise;
  }

  function maybeAutoFlush(reason) {
    if (!config.writeToCart) return;
    var queue = getQueue();
    if (!queue.length) return;
    var now = Date.now();
    if (now - lastAutoFlushAt < autoFlushMinGapMs) return;
    lastAutoFlushAt = now;
    flush(reason || 'auto');
  }

  function startAutoFlush() {
    if (!config.writeToCart || autoFlushTimer) return;
    autoFlushTimer = setInterval(function () {
      maybeAutoFlush('interval');
    }, autoFlushIntervalMs);
    setTimeout(function () {
      maybeAutoFlush('initial');
    }, 3000);
  }

  function log(evt, data, opts) {
    enqueue(buildEvent(evt, data), opts || {});
  }

  function logAndFlush(evt, data) {
    enqueue(buildEvent(evt, data));
    return flush('immediate');
  }

  function classifyClick(el) {
    if (!el) return '';
    if (el.closest('header')) return 'header';
    if (el.closest('nav')) return 'nav';
    if (el.closest('footer')) return 'footer';
    if (el.closest('[data-sbr-location]')) return el.closest('[data-sbr-location]').getAttribute('data-sbr-location') || '';
    return 'body';
  }

  function isCheckoutTrigger(el) {
    if (!el) return false;
    if (el.closest('form[action*="/checkout"]')) return true;
    if (el.closest('button[name="checkout"], input[name="checkout"], [data-checkout], .shopify-payment-button__button')) return true;
    var link = el.closest('a');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/checkout') === 0 || href.indexOf('/checkouts/') === 0) return true;
    }
    return false;
  }

  function handleNavClick(e) {
    if (!config.logNavClicks) return;
    if (!e || !e.target) return;

    var anchor = e.target.closest('a');
    if (!anchor) return;
    if (anchor.hasAttribute('data-sbr-ignore')) return;

    var href = anchor.getAttribute('href');
    if (!href) return;
    if (href.indexOf('#') === 0) return;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    log('nav_click', {
      from: window.location.pathname + window.location.search,
      to: url.pathname + url.search + url.hash,
      text: (anchor.textContent || '').trim().slice(0, 140),
      label: (anchor.getAttribute('aria-label') || anchor.getAttribute('title') || (anchor.textContent || '')).trim().slice(0, 140),
      location: classifyClick(anchor)
    });
  }

  function handleCheckout(e) {
    if (!e || !e.target) return;
    if (!isCheckoutTrigger(e.target)) return;

    var now = Date.now();
    if (now - lastCheckoutLogAt < 1500) return;
    lastCheckoutLogAt = now;

    logAndFlush('checkout_start', {
      method: e.type || 'click',
      from: window.location.pathname + window.location.search
    });
  }

  function handleFormSubmit(e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/checkout') === -1) return;
    handleCheckout(e);
  }

  function handleProductFormSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? idInput.value : '';
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    log('add_to_cart', {
      source: 'product_form',
      variant_id: variantId || null,
      quantity: quantity,
      product_title: cfg.pageTitle || document.title,
      button_label: 'Add to Cart'
    }, { flush: true });
  }

  var lastAtcKey = '';
  var lastAtcAt = 0;

  function handleAtcClick(e) {
    if (!e || !e.target) return;
    var btn = e.target.closest('.js-go-cart-add-to-cart, .product-submit, .pdp-atc-btn, .sticky-atc-btn, .recipe-ingredient__atc, [data-add-to-cart]');
    if (!btn) return;

    var now = Date.now();
    var form = btn.closest('form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var variantId = btn.getAttribute('data-variant-id') || (idInput ? idInput.value : '');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;
    var label = (btn.getAttribute('aria-label') || btn.getAttribute('title') || btn.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 140);
    var productTitle = (btn.getAttribute('data-product-title') || (form && form.getAttribute('data-product-title')) || cfg.pageTitle || document.title || '').trim();
    var source = btn.classList.contains('recipe-ingredient__atc') ? 'recipe_atc' : 'button';

    var key = [variantId, label, source].join('|');
    if (key && key === lastAtcKey && now - lastAtcAt < 1500) return;
    lastAtcKey = key;
    lastAtcAt = now;

    log('add_to_cart', {
      source: source,
      variant_id: variantId || null,
      quantity: quantity,
      product_title: productTitle,
      button_label: label
    }, { flush: true });
  }

  function init() {
    var sessionInfo = getSession();
    if (sessionInfo.isNew) {
      log('session_start', {
        landing_url: window.location.href,
        referrer: document.referrer || ''
      });
    }

    log('page_view', {
      url: window.location.href,
      referrer: document.referrer || ''
    });

    startAutoFlush();

    document.addEventListener('click', function (e) {
      handleNavClick(e);
      handleCheckout(e);
    });

    document.addEventListener('submit', function (e) {
      handleFormSubmit(e);
      handleProductFormSubmit(e);
    }, true);

    document.addEventListener('click', function (e) {
      handleAtcClick(e);
    }, true);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) maybeAutoFlush('visibility');
    });
    window.addEventListener('pagehide', function () {
      maybeAutoFlush('pagehide');
    });
  }

  window.SBRTracker = {
    log: log,
    logAndFlush: logAndFlush,
    flush: flush
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
